import { parseISO, differenceInMilliseconds } from "date-fns";
import { replace as l_replace, eachRight as l_eachRight, split as l_split, last as l_last, get as l_get } from "lodash-es";
import { trans as iwp_trans } from 'laravel-vue-i18n';
import axios from 'axios';


export function getHttpsUrl(url) {
    if ( !url ) {
        return '';
    }
    if ( url.includes('//:') ) {
        url = url.replace('https//:', 'https://');
        url = url.replace('http//:', 'https://');
    }
    
    if ( !url.includes('://') ) {
        url = 'https://' + url;
    } else {
        url = url.replace('http://', 'https://');
    }
    
    if ( url.length < 14 ) {
        return '';
    }
    return url.endsWith('/') ? url.slice(0, -1) : url;
}

export function openWindowWithPost(url, data, target = "_blank") {
    const dataForm = document.createElement("form");
    dataForm.style.display = "none";
    dataForm.target = target; //Make sure the window name is same as this value
    dataForm.method = "POST";
    dataForm.action = url;
    for (const key in data) {
        const postData = document.createElement("input");
        postData.type = "hidden";
        postData.name = key;
        postData.value = data[key];
        dataForm.appendChild(postData);
    }
    document.body.appendChild(dataForm);
    dataForm.submit();
}

export const trans = (string, args) => {
    let value = l_get(window.i18n, string);

    const defaultVal = l_last(l_split(string, "."));
    if (value) {
        l_eachRight(args, (paramVal, paramKey) => {
            value = l_replace(value, `:${paramKey}`, paramVal);
        });
    } else {
        value = defaultVal;
    }
    return value;
};

export const editSnapshotFormData = (snapshot) => {
    const bodyFormData = new FormData();
    bodyFormData.append('launch_version', snapshot.is_monetized ? 'v2' : snapshot.launch_version);
    bodyFormData.append('name', snapshot.name);
    bodyFormData.append('slug', snapshot.slug);
    bodyFormData.append('description', (snapshot.display_text ?? ''));
    bodyFormData.append('active', snapshot.active);
    bodyFormData.append('mark_as_public', ((snapshot.mark_as_public == 1 || snapshot.mark_as_public == true) ? 'true' : 'false'));
    bodyFormData.append('email_required', snapshot.email_required ? 'true' : 'false');
    bodyFormData.append('collect_email', snapshot.collect_email ? 'true' : 'false');
    bodyFormData.append('collect_name', snapshot.collect_name ? 'true' : 'false');
    bodyFormData.append('send_credentials', snapshot.send_credentials ? 'true' : 'false');
    bodyFormData.append('hide_privacy_checkbox', snapshot.hide_privacy_checkbox ? 'true' : 'false');
    bodyFormData.append('disallow_file_modification', snapshot.disallow_file_modification ? 'true' : 'false');
    bodyFormData.append('auto_launch', snapshot.auto_launch ? 'true' : 'false');
    bodyFormData.append('site_cloning', snapshot.site_cloning ? 'true' : 'false');
    bodyFormData.append('redirect_url', snapshot.redirect_url ? snapshot.redirect_url : '');
    bodyFormData.append('site_life_time', snapshot.site_life_time);
    bodyFormData.append('sync_emails_to', snapshot.sync_emails_to);
    bodyFormData.append('instant_template', snapshot.instant_template ? 'true' : 'false');
    bodyFormData.append('custom_email_subject', snapshot.custom_email_subject);
    bodyFormData.append('custom_email_body', snapshot.custom_email_body);
    bodyFormData.append('custom_privacy_text', snapshot.custom_privacy_text);
    bodyFormData.append('custom_css', snapshot.custom_css);
    bodyFormData.append('zapier_webhook_url', snapshot.zapier_webhook_url ? snapshot.zapier_webhook_url : '');
    bodyFormData.append('post_creation_command', snapshot.post_creation_command ? snapshot.post_creation_command : '');
    bodyFormData.append('logo_file_name', snapshot.logo_file_name);
    bodyFormData.append('custom_primary_color', snapshot.custom_primary_color ? snapshot.custom_primary_color : '#15b881');
    bodyFormData.append('custom_accent_color', snapshot.custom_accent_color ? snapshot.custom_accent_color : '#ffffff');
    bodyFormData.append('hosting_account_id', snapshot.hosting_account_id ? snapshot.hosting_account_id : '');
    bodyFormData.append('server_type', snapshot.server_type ? snapshot.server_type : 'instawp_serve');
    bodyFormData.append('is_my_hosting', snapshot.is_my_hosting ? snapshot.is_my_hosting : 'false');
    bodyFormData.append('hosting_account_site_default_values', snapshot.hosting_account_site_default_values ? snapshot.hosting_account_site_default_values : []);

    return bodyFormData;
};

export const editTemplateFormData = (template) => {
    const bodyFormData = new FormData();
    bodyFormData.append('launch_version', template.is_monetized ? 'v2' : template.launch_version);
    bodyFormData.append('name', template.name);
    bodyFormData.append('slug', template.slug);
    bodyFormData.append('description', (template.display_text ?? ''));
    bodyFormData.append('active', template.active);
    bodyFormData.append('mark_as_public', ((template.mark_as_public == 1 || template.mark_as_public == true) ? 'true' : 'false'));
    bodyFormData.append('email_required', template.email_required ? 'true' : 'false');
    bodyFormData.append('collect_email', template.collect_email ? 'true' : 'false');
    bodyFormData.append('collect_name', template.collect_name ? 'true' : 'false');
    bodyFormData.append('send_credentials', template.send_credentials ? 'true' : 'false');
    bodyFormData.append('hide_privacy_checkbox', template.hide_privacy_checkbox ? 'true' : 'false');
    bodyFormData.append('disallow_file_modification', template.disallow_file_modification ? 'true' : 'false');
    bodyFormData.append('auto_launch', template.auto_launch ? 'true' : 'false');
    bodyFormData.append('site_cloning', template.site_cloning ? 'true' : 'false');
    bodyFormData.append('redirect_url', template.redirect_url ? template.redirect_url : '');
    bodyFormData.append('site_life_time', template.site_life_time);
    bodyFormData.append('sync_emails_to', template.sync_emails_to);
    bodyFormData.append('instant_template', template.instant_template ? 'true' : 'false');
    bodyFormData.append('custom_email_subject', template.custom_email_subject);
    bodyFormData.append('custom_email_body', template.custom_email_body);
    bodyFormData.append('custom_privacy_text', template.custom_privacy_text);
    bodyFormData.append('custom_css', template.custom_css);
    bodyFormData.append('zapier_webhook_url', template.zapier_webhook_url ? template.zapier_webhook_url : '');
    bodyFormData.append('post_creation_command', template.post_creation_command ? template.post_creation_command : '');
    bodyFormData.append('logo_file_name', template.logo_file_name);
    bodyFormData.append('custom_primary_color', template.custom_primary_color ? template.custom_primary_color : '#15b881');
    bodyFormData.append('custom_accent_color', template.custom_accent_color ? template.custom_accent_color : '#ffffff');
    bodyFormData.append('hosting_account_id', template.hosting_account_id ? template.hosting_account_id : '');
    bodyFormData.append('server_type', template.server_type ? template.server_type : 'instawp_serve');
    bodyFormData.append('is_my_hosting', template.is_my_hosting ? template.is_my_hosting : 'false');
    bodyFormData.append('hosting_account_site_default_values', template.hosting_account_site_default_values ? template.hosting_account_site_default_values : []);

    return bodyFormData;
};

export const readableFileSize = (size) => {
    const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
}

export const setObjectProperty = (object, path, value) => {
    const parts = path.split('/');
    const limit = parts.length - 1;
    for (let i = 0; i < limit; ++i) {
        const key = parts[i];
        object = object[key] ?? (object[key] = {});
    }
    const key = parts[limit];
    object[key] = value;
};

export const setCanonicalUrl = (url) => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    document.head.appendChild(link);
}

// export function setCookie(name, value, days) {
//     let expires = "";
//     if (days) {
//         const date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }
// export function getCookie(name) {
//     const nameEQ = name + "=";
//     const ca = document.cookie.split(';');
//     for (let i = 0; i < ca.length; i++) {
//         let c = ca[i];
//         while (c.charAt(0) == ' ') c = c.substring(1, c.length);
//         if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//     }
//     return null;
// }
// export function eraseCookie(name) {
//     document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
// }

export const calculateFileSize = (number) => {
    if (number === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(number) / Math.log(k));
    return parseFloat((number / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function numberShortFormatter(num, digits) {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup.slice().reverse().find(function (item) {
        return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

// export function isNumeric(n) {
//     return !isNaN(parseFloat(n)) && isFinite(n);
// }

export function getURLParams(key) {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    return params.get(key)
}

export function cdn(fileurl) {
    let url = fileurl
    if (url.match(/^http[s]{0,1}:/g)) {
        return url
    }

    if (!url.match(/^[/]/)) {
        url = '/' + url
    }

    let app_env = import.meta.env.VITE_APP_ENV;
    if (app_env == 'local' || app_env == 'develop') {
        return url
    }

    if (app_env == 'staging') {
        return  'https://app-instawp-staging.b-cdn.net' + url
    }

    return 'https://cdn.instawp.io' + url
}

export const tagColours = [
    '#854d0e',
    '#9d174d',
    '#ffa500',
    '#92400e',
    '#065f46',
    '#155e75',
    '#9f1239',
    '#008000',
    '#4b0082',
    '#065f46',
    '#5b21b6',
    '#991b1b',
    '#1e40af',
    '#ffd045',
];

export function getClientReferenceId() {
    return window.Rewardful && window.Rewardful.referral || ('checkout_' + (new Date).getTime());
}

/**
 * Validate if URL is blocked by WAF/CDN before migration
 *
 * @param {string} url - The WordPress site URL to validate
 * @param {string|null} groupUuid - Optional migration group UUID for error tracking
 * @param {Object} options - Additional options
 * @param {Function} options.onError - Callback when WAF blocking is detected
 * @param {Function} options.setNotification - Function to show notification
 * @param {string} options.whiteLabelSlug - White label slug for guest (unauthenticated) validation
 * @returns {Promise<boolean>} - true if URL is accessible, false if blocked
 */
export async function validateWafBlocking(url, groupUuid = null, options = {}) {
    const { setNotification=null, onError=null, whiteLabelSlug=null } = options;

    const handleError = (errorMessage) => {
        if (setNotification && typeof setNotification === 'function') {
            setNotification({
                heading: iwp_trans('alert'),
                subHeading: errorMessage,
                type: 'error',
            });
        }
        if (onError && typeof onError === 'function') {
            onError(errorMessage);
        }
    };

    try {
        const payload = { url };
        if (groupUuid) {
            payload.g_id = groupUuid;
        }

        // Use white label endpoint if slug is provided (for unauthenticated requests)
        const endpoint = whiteLabelSlug
            ? `/api/v2/migrate-white-label/connects/${whiteLabelSlug}/validate-rest-url-waf`
            : '/api/v2/migrates-v3/validate-rest-url-waf';

        const response = await axios.post(endpoint, payload);
        // Check for false status in response
        if (response?.data?.status !== true) {
            handleError(response?.data?.message || iwp_trans('rest_url_not_accessible'));
            return false;
        }

        return true;
    } catch (error) {
        // On other exceptions (network error, 5xx), allow migration to proceed
        console.log('WAF validation request failed, allowing migration to proceed:', error);
        return true;
    }
}

export function openCrispChat() {
    if (!window.$crisp) {
        return;
    }

    try {
        window.$crisp.push(['do', 'chat:show']);
        setTimeout(() => {
            window.$crisp.push(["do", "chat:toggle"])
        }, 100);
    } catch (error) {
        console.error('Error opening chat:', error);
    }
}

